export default __webpack_public_path__ + "static/media/3rd-place-badge.db625e72.svg";